import React from 'react';

import {
  Flex,
  icons,
} from 'web-styled';

import * as S from './styled';

type Props = {
  size?: number,
  avatar: string,
  fullName: string | null,
};

const Author = ({
  size,
  avatar,
  fullName,
}: Props) => (
  <Flex spacing={5} noPrint>
    <S.Avatar
      size={size}
      onError={(e) => {
        e.target.src = icons.clientAvatarWhitePlaceHolder;
      }}
    >
      <img src={avatar || icons.clientAvatarWhitePlaceHolder} alt={fullName || ''} />
    </S.Avatar>
    <S.Meta>
      <span>Author</span>
      <S.Name>
        {fullName}
      </S.Name>
    </S.Meta>
  </Flex>
);

Author.defaultProps = {
  size: 28,
};

export default Author;
